import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import acc from 'accounting'
import tabgrid from "../../../../utilities/TabGrid";
import initialData from "../../../../utilities/initialData/initialData";

export default class DlaJednejTrasyTabelaSzczegolowaTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miesiace: [],
        };
    }

    renderCena(cell, row) {
        return acc.formatMoney(cell)
    }

    renderStatusy(cell, row) {
        if(Boolean(cell)){
            if(cell==1){
                return 'opłacony'
            }
            else if(cell=='-1')return 'do opłaty'
        }
    }

    renderKierunek(cell, row) {
        if (cell === 1) { return 'jednostronny'
        }
        else if (cell === 2) { return 'dwustronny'
        }
        else return cell
    }

    renderOkres(cell, row) {
        if (cell === 'P1') { return 'I połowa'
        }
        else if (cell === 'P2') { return 'II połowa'
        }
        else if (cell === 'M1') { return 'cały miesiąc'

        }
        else return cell
    }

    renderMiesiacRok(cell, row) {
        let msc = initialData.returnArrayMiesiace().find(m => m.value === row.mies)
        return row.rok + ', ' + msc.label.substr(0,4)
    }

    render() {

        let okresy = {
            "P1": "I połowa",
            "P2": "II połowa",
            "M1": "cały miesiąc",
        }

        let kierunki = {
            1: "jednostronny",
            2: "dwustronny"
        }

        let statusy = {
            'NOWA':'nowa',
            'PRZYJETA':'przyjęta',
            'GOTOWA':'gotowa',
            'ZWROCONA':'zwrócona',

        }

        let statusybil = {
            '-1':'do opłaty',
            '1':'opłacony'
        }

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                hover
                >
                    <TableHeaderColumn dataField='pesel' isKey hidden={true}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Pesel</TableHeaderColumn>
                    <TableHeaderColumn dataField='rok'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj',disabled:true}}
                                     dataFormat={this.renderMiesiacRok}
                    >Miesiąc</TableHeaderColumn>
                    <TableHeaderColumn dataField='okres' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'SelectFilter', options: okresy, selectText: ''}} formatExtraData={okresy}
                                       dataFormat={this.renderOkres}
                    >Okres</TableHeaderColumn>
                    <TableHeaderColumn dataField='imie_nazwisko' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Klient</TableHeaderColumn>
                    <TableHeaderColumn dataField='pesel' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Pesel</TableHeaderColumn>
                    <TableHeaderColumn dataField='naz_mi_od' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Od miejscowości</TableHeaderColumn>
                    <TableHeaderColumn dataField='naz_mi_do' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Do miejscowości</TableHeaderColumn>
                    <TableHeaderColumn dataField='kierunek' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'SelectFilter', options: kierunki, selectText: ''}} formatExtraData={kierunki}
                                       dataFormat={this.renderKierunek}
                    >Kierunek</TableHeaderColumn>
                    <TableHeaderColumn dataField='cena' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderCena}
                    >Cena</TableHeaderColumn>
                    <TableHeaderColumn dataField='rodz' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Rodzaj</TableHeaderColumn>
                    <TableHeaderColumn dataField='status' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'SelectFilter', options: statusy, selectText: ''}} formatExtraData={statusy}
                    >Stat. karty</TableHeaderColumn>
                    <TableHeaderColumn dataField='stat_bil' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'SelectFilter', options: statusybil, selectText: '', condition:'like'}} formatExtraData={statusybil}
                                       dataFormat={this.renderStatusy}
                    >Opłacony?</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazMiesiecznych/components/DlaJednejTrasyTabelaSzczegolowaTable.js